import React from 'react'
import UserLoginPage from '../components/user/user-login'

export default function UserLogin() {
    return (
        <div className='admin'>
            <UserLoginPage />
        </div>
    )
}
